<script setup>
import {computed, onMounted, ref} from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import Breadcrumbs from "../Breadcrumbs.vue";
import {parseTime} from "@/utils/ruoyi"
const showMenu = ref(false);
const store = useStore();
const isRTL = computed(() => store.state.isRTL);

const route = useRoute();
// 获取路由实例
const router = useRouter();

const currentRouteName = computed(() => {
  console.log(' = name', route.name)
  return route.name;
});
const currentDirectory = computed(() => {
  let dir = route.path.split("/")[1];
  return dir.charAt(0).toUpperCase() + dir.slice(1);
});


const name = computed(() => store.getters.getName);
const currentLanguage = computed(() => store.getters.getLanguage);


const messageList = computed(() => store.getters.getMessageList);
const unreadCount = computed(() => store.getters.getUnreadCount);


import i18n from "@/language";
import {getToken} from "@/utils/auth";
import { useI18n } from 'vue-i18n'
const { locale } = useI18n()



const isLoggedIn = getToken();

const languageOptions = [{
  value: 'zh-cn',
  label: '简体中文'
},{
  value: 'en-us',
  label: 'English'
},{
  value: 'tr-tr',
  label: 'Türkçe'
},{
  value:'ru-ru',
  label: 'русский язык'
}
]

const tabLanguage = (e)=>{
  console.log('e', e)
  store.dispatch('setLanguage',e)
  localStorage.setItem('localeLanguage', e)
  locale.value = e
  console.log('locale', locale.value)
  document.title = i18n.global.t('site.name')
}

const minimizeSidebar = () => store.commit("sidebarMinimize");
const toggleConfigurator = () => store.commit("toggleConfigurator");

const closeMenu = () => {
  setTimeout(() => {
    showMenu.value = false;
  }, 100);
};


const toMessage = ()=>{
  router.push({
    path: '/message'
  })
}

onMounted(()=>{
  store.dispatch('setUserInfo')
  store.dispatch('setLanguage',localStorage.getItem('localeLanguage'))
})

</script>
<template>
  <nav
    class="navbar navbar-main navbar-expand-lg px-0 mx-4 shadow-none border-radius-xl"
    v-bind="$attrs"
    id="navbarBlur"
    data-scroll="true"
  >
    <div class="px-3 py-1 container-fluid">
      <breadcrumbs
        :current-page="currentRouteName"
        :current-directory="currentDirectory"
      />

      <div
        class="mt-2 collapse navbar-collapse mt-sm-0 me-md-0 me-sm-4"
        id="navbar"
      >
        <div
          class="pe-md-3 d-flex align-items-center ms-md-auto"
        >
<!--          <div class="input-group">-->
<!--            <span class="input-group-text text-body">-->
<!--              <i class="fas fa-search" aria-hidden="true"></i>-->
<!--            </span>-->
<!--            <input-->
<!--              type="text"-->
<!--              class="form-control"-->
<!--              placeholder="Type here..."-->
<!--            />-->
<!--          </div>-->
        </div>
        <ul class="navbar-nav justify-content-end">
          <li class="nav-item d-flex align-items-center px-0 nav-link font-weight-bold text-white">
            <i class="fas fa-globe fa-lg me-sm-2"></i>
            <el-select v-model="currentLanguage" placeholder="Select" style="width: 120px; margin-right: 20px;" @change="tabLanguage">
              <el-option
                  v-for="item in languageOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              />
            </el-select>
          </li>

          <li class="nav-item d-flex align-items-center">
            <i class="fa fa-user me-sm-2"></i>
            <span class="d-sm-inline d-none">{{name || '--'}}</span>
<!--            <router-link-->
<!--              v-else-->
<!--              :to="{ path: '/signin' }"-->
<!--              class="px-0 nav-link font-weight-bold text-white"-->
<!--              target="_blank"-->
<!--            >-->
<!--              <span class="d-sm-inline d-none">{{$t('login.signIn')}}</span>-->
<!--            </router-link>-->
          </li>
          <li class="nav-item d-xl-none ps-3 d-flex align-items-center">
            <a
              href="#"
              @click="minimizeSidebar"
              class="p-0 nav-link text-white"
              id="iconNavbarSidenav"
            >
              <div class="sidenav-toggler-inner">
                <i class="sidenav-toggler-line bg-white"></i>
                <i class="sidenav-toggler-line bg-white"></i>
                <i class="sidenav-toggler-line bg-white"></i>
              </div>
            </a>
          </li>
          <li class="px-3 nav-item d-flex align-items-center">
            <a class="p-0 nav-link text-white" @click="toggleConfigurator">
              <i class="cursor-pointer fa fa-cog fixed-plugin-button-nav"></i>
            </a>
          </li>
          <li
            class="nav-item dropdown d-flex align-items-center"
            :class="isRTL ? 'ps-2' : 'pe-2'"
          >
            <a
              href="#"
              class="p-0 nav-link text-white"
              :class="[showMenu ? 'show' : '']"
              id="dropdownMenuButton"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              @click="showMenu = !showMenu"
              @blur="closeMenu"
            >
              <i class="cursor-pointer fa fa-bell"></i>
              <el-link type="danger" class="font-weight-bolder" style="position: absolute; left: 5px; top: 3px;"> {{unreadCount || ''}}</el-link>
            </a>
            <ul
              class="px-2 py-3 dropdown-menu dropdown-menu-end me-sm-n4"
              :class="showMenu ? 'show' : ''"
              aria-labelledby="dropdownMenuButton"
            >
              <li class="mb-2" v-for="(item,index) in messageList" :key="index" @click="toMessage">
                <a class="dropdown-item border-radius-md" href="javascript:;">
                  <div class="py-1 d-flex">
<!--                    <div class="my-auto">-->
<!--                      <img-->
<!--                        src="../../assets/img/team-2.jpg"-->
<!--                        class="avatar avatar-sm me-3"-->
<!--                        alt="user image"-->
<!--                      />-->
<!--                    </div>-->
                    <div class="d-flex flex-column justify-content-center">
                      <h6 class="mb-1 text-sm font-weight-normal">
                        <span class="font-weight-bold">{{$t('message.messageTip')}}:</span>
                        {{item.templateContent.split('\n')[0]}}
                      </h6>
                      <p class="mb-0 text-xs text-secondary">
                        <i class="fa fa-clock me-1"></i>
                       {{parseTime(item.createTime)}}
                      </p>
                    </div>
                  </div>
                </a>
              </li>

              <el-empty v-if="messageList && messageList.length === 0" @click="toMessage" :image-size="40" :description="$t('message.noNewsYet')" />

            </ul>

          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>
